import { useState, useEffect, useRef } from "react";

import Input from "../../components/Input";

const CopyElement = ({ url }) => {
	const [copied, setCopied] = useState(false);

	const element = useRef(null);

	useEffect(() => {
		if (copied) {
			const timeoutId = setTimeout(() => {
				setCopied(false);
			}, 2000);

			return () => clearTimeout(timeoutId);
		}
	}, [copied]);

	const handleClick = () => {
		const copyText = element.current;
		copyText.select();
		copyText.setSelectionRange(0, 99999); // For mobile devices

		navigator.clipboard.writeText(copyText.value);
		setCopied(true);
	};

	return (
		<div className="form-group">
			<Input
				name="link"
				label="Registration Link"
				reqd={false}
				value={url}
				update={null}
				errors={[]}
				note=""
				readonly={true}
				ref={element}
			/>

			{copied ? (
				<p>
					<i className="fa fa-check" /> &nbsp;Copied{" "}
				</p>
			) : (
				<button
					type="button"
					className="btn btn-default"
					onClick={() => handleClick()}
					title="Copy to clipboard"
				>
					<i className="fa fa-files-o" />
				</button>
			)}
		</div>
	);
};

export default CopyElement;
